<template>
  <BlockRepeater
    v-slot="slotProps"
    class="SavedDocument"
    title=""
    label="Voeg een document toe"
    :path="path"
    :values="values"
    :disabled="disabled"
    :deleted="evaluateDeletedState"
    :compact="true"
  >
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :validation="validation"
      :disabled="disabled"
      :path="`${path}.${slotProps.id}`"
      :viewer="viewer"
    />
  </BlockRepeater>
</template>

<script>
import BlockRepeater from '@/components/form/BlockRepeater'
import FieldSet from '@/components/form/FieldSet'

import { helpers } from 'vuelidate/lib/validators'
import { isUrl } from '@/services/validation'

export default {
  name: 'SavedDocument',
  components: { BlockRepeater, FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Party',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'PartyName': {
          'type': 'string',
          'title': 'Leverancier',
          'readonly': true,
        },
        'DeliveryDocumentsReceivedDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Datum dat de opleveringsdocumenten zijn ontvangen',
        },
        'LinkToDeliveryDocuments': {
          'type': 'string',
          'format': 'url',
          'title': 'Link naar de map met de opleveringsdocumenten',
        },
        'deleted_at': {
          type: 'hidden',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['PartyName', 'DeliveryDocumentsReceivedDate'],
      }, {
        'columns': '1fr 0px',
        'fields': ['LinkToDeliveryDocuments', 'deleted_at'],
      }],
      validation: {
        LinkToDeliveryDocuments: {
          isUrl: (value) => !helpers.req(value) || isUrl(value),
        },
      },
    }
  },
  methods: {
    evaluateDeletedState({ index }) {
      return !! (
        this.values[this.path] && this.values[this.path][index] && this.values[this.path][index].deleted_at
      )
    },
  },
}
</script>
